


<template lang="jade">

	div.home
		video-nav
		logo
		films-nav
		credits
		contact
		posters
		videos
		mobile


</template>



<script>



	import videoNav from './video-nav.vue'
	import logo from './logo.vue'
	import filmsNav from './nav.vue'
	import credits from './credits.vue'
	import contact from './contact.vue'
	import posters from './posters.vue'
	import videos from './videos.vue'
	import mobile from './mobile.vue'



	const $cmp = {
		name : 'home',
		components : {
			videoNav,
			logo,
			filmsNav,
			credits,
			contact,
			posters,
			videos,
			mobile
		}
	}



	$cmp.data = function() {
		return {
			films : {}
		}
	}



	$cmp.mounted = function() {
		var $this = this
		$this.getFilmsPage()
	}



	$cmp.methods = {}

	$cmp.methods.getFilmsPage = function() {

		var $this = this

		var path = '/pages?slug=films'
			path += '&status=' + window.wp.status

		wp.request({
			path : path
		}, function(data, status, xhr) {
			$this.$set($this.$store.pages, 'films', data[0])
			$this.getFilms()
		})

	}

	$cmp.methods.getFilms = function() {

		var $this = this
		var $pages = $this.$store.pages

		var path = '/pages?parent=' + $pages.films.id
			path += '&order=asc'
			path += '&status=' + window.wp.status

		wp.request({
			path : path
		}, function(data, status, xhr) {
			$this.$set($this.$store.pages.films, 'children', data)
			var $children = $this.$store.pages.films.children
			var rand = Math.round(Math.random() * $children.length)
			var $film = $children[rand]
			$this.$router.push({ path : '/films/' +  $film.slug })
		})

	}



	export default $cmp



</script>



<style lang="stylus" scoped>

	.home
		position absolute
		top 0px
		left 0px
		right 0px
		bottom 0px
		color #000000
		overflow hidden

</style>



// WEBPACK FOOTER //
// src/components/home/home.vue